import React, {useContext, useState, useEffect, useReducer} from 'react';
import { useNavigate } from 'react-router-dom'; 
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import utilities from '../utilities'
import SelectControl from '../Components/SelectControl';
import {AuthContext} from '../context/AuthContext'
import swal from 'sweetalert'


const Rejected = (props) => {

    const {userInfo} = useContext(AuthContext);
    const navigate = useNavigate();
    
    const {data} = useApi( {url: '/Registration/GetScrutinyApplications?status=Rejected', method: 'get' });
    const {data: scrutinyOfficers} = useApi( {url: '/Registration/GetScrutinyOfficers', method: 'get' });


  const UploadDocument = (regID, document) => {
    var registrationID = utilities.encryptData(regID.toString());
    var document = utilities.encryptData(document);
    navigate('/registration/scrutiny/objection/' + registrationID + "/" + document );   
  }


  return (
    <>

<div className="content">
    <div className="header">
        <label className="title"> Objection(s) in Applications </label>
    </div>
 
    <p className='text-primary'>***These application(s) are found deficient. Please upload the correct document(s) to remove deficiences as early as possible. Please note that only valid applications will all respect will be issued registration number and will be eligible to appear in examination.</p>

    <p className='text-danger'>***Documents of your institutes are checked by following Scrutiny Officers. Contact them for clearance of objections (if any) and issuance of registration numbers:</p>
    <ul className='text-danger'>
        {!scrutinyOfficers ? (<></>) : (scrutinyOfficers.map((officer, idx) => {
                return (
                    <>        
                        <li>{officer.fullName} ({officer.mobileNo})</li>
                    </>
                )
        }))}
    </ul>


    {!data ? (<Loader />) : (

    
                                <div className="body">
                                    <div className="animate-bottom">
                                                    {data.map((category, index) => {
                                                        return (
                                                            <div className="table-responsive" > 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <caption >
                                                                    <span key={index}> {category.name} </span>
                                                                </caption>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Session</th>
                                                                        <th>Category</th>
                                                                        <th>Student Name</th>
                                                                        <th>Father Name</th>
                                                                        <th>CNIC</th>
                                                                        <th>Objection(s)</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>

                                                                {category.students.map((student, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={student.studentID}>
                                                                                <td>{student.session}</td>
                                                                                <td>{student.category}</td>                                                                                
                                                                                <td>{student.studentName}</td>
                                                                                <td>{student.fatherName}</td>
                                                                                <td>{student.cnic}</td>
                                                                                <td style={{textAlign:'left'}}>
                                                                                    <span className='text-danger'>
                                                                                        {student.isValidCNIC == false ? [student.cnicObjection, student.isPendingCorrectionCNIC == false ? <i class="fa fa-check-square-o text-success ms-2" aria-hidden="true"></i>: null, <br/>,<hr style={{margin:'5px', color: 'black'}}></hr>] : null}
                                                                                        {student.isValidMatricDMC == false ? [student.matricObjection, student.isPendingCorrectionMatric == false ? <i class="fa fa-check-square-o text-success ms-2" aria-hidden="true"></i>: null, <br/>, ,<hr style={{margin:'5px', color: 'black'}}></hr>] : null}
                                                                                        {student.isValidMatricVerification == false ? [student.verificationObjection, student.isPendingCorrectionVerification == false ? <i class="fa fa-check-square-o text-success ms-2" aria-hidden="true"></i>: null]: null}
                                                                                    </span>
                                                                                </td>                                                                                
                                                                                <td style={{textAlign: 'center'}}> 
                                                                                    {student.isPendingCorrectionCNIC == true ? [<button className='btn btn-sm btn-outline-primary mb-2' onClick={() => UploadDocument(student.registrationID, 'cnic')} > Upload CNIC </button>, <br/>] : null}
                                                                                    {student.isPendingCorrectionMatric == true ? [<button className='btn btn-sm btn-outline-primary mb-2' onClick={() => UploadDocument(student.registrationID, 'matric')} > Upload Matric DMC </button>, <br/>] : null}
                                                                                    {student.isPendingCorrectionVerification == true ? [<button className='btn btn-sm btn-outline-primary' onClick={() => UploadDocument(student.registrationID, 'verification')} > Upload Matric Verification </button>, <br/>] : null}
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>
                                                        );

                                                    })
                                                    }

                                    </div>


                                    
                                </div>
        )
    }
                                </div>

    </>
  );

};

export default Rejected;